import React, { useEffect, useState } from 'react'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import companyService from '../../services/data/company.service'
import currencyFormat from '../../helpers/currencyFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown'
import { Sidebar } from 'primereact/sidebar'

const STATUS_BADGE = {
    dentro: <span className='badge bg-success'>Dentro</span>,
    acima: <span className='badge bg-danger'>Acima</span>,
    abaixo: <span className='badge bg-warning text-dark'>Abaixo</span>,
    sem_estrutura: <span className='badge bg-secondary'>Sem estrutura</span>,
    sem_dados: <span className='badge bg-light text-muted'>Sem dados</span>,
}

export default function QuadroCargos() {
    const [items, setItems] = useState([])
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [selection, setSelection] = useState(null)
    const [showSidebar, setShowSidebar] = useState(false)

    const [search, setSearch] = useState('')
    const [statusFilter, setStatusFilter] = useState('')
    const [subcompanySel, setSubcompanySel] = useState(null)
    const [departmentSel, setDepartmentSel] = useState(null)
    const [subcompanyItems, setSubcompanyItems] = useState([])
    const [departmentItems, setDepartmentItems] = useState([])

    function buildFilters() {
        const f = {}
        if (search) f.search = search
        if (statusFilter) f.salary_status = statusFilter
        if (subcompanySel) f.subcompany_id = subcompanySel.id
        if (departmentSel) f.department_id = departmentSel.id
        return f
    }

    function loadItems(p = 1, filters = {}) {
        setLoading(true)
        setError('')
        salaryAnalysisService.listQuadro(p, filters)
            .then(r => { setItems(r.results || []); setCount(r.count || 0) })
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }

    useEffect(() => { loadItems(page, buildFilters()) }, [page])
    useEffect(() => {
        companyService.autoCompleteSubCompany('')
            .then(r => setSubcompanyItems(r || []))
            .catch(() => setSubcompanyItems([]))
        companyService.autoCompleteDepartment('')
            .then(r => setDepartmentItems(r || []))
            .catch(() => setDepartmentItems([]))
    }, [])

    function applyFilters() { setPage(1); loadItems(1, buildFilters()) }

    function clearFilters() {
        setSearch(''); setStatusFilter(''); setSubcompanySel(null)
        setDepartmentSel(null)
        setPage(1); loadItems(1, {})
    }

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Quadro de Cargos & Salários</span>
                        </div>

                        {/* Filtros */}
                        <div className='row m-3 g-2 align-items-end'>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Buscar</label>
                                <input className='form-control form-control-sm' placeholder='Cargo, código, CBO...'
                                    value={search} onChange={e => setSearch(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && applyFilters()} />
                            </div>
                            <div className='col-md-2'>
                                <label className='form-label small fw-bold'>Organização</label>
                                <Dropdown className='w-100' placeholder='Organização'
                                    value={subcompanySel}
                                    options={subcompanyItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setSubcompanySel(e.value)} />
                            </div>
                            <div className='col-md-2'>
                                <label className='form-label small fw-bold'>Departamento</label>
                                <Dropdown className='w-100' placeholder='Departamento'
                                    value={departmentSel}
                                    options={departmentItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setDepartmentSel(e.value)} />
                            </div>
                            <div className='col-md-2'>
                                <label className='form-label small fw-bold'>Status</label>
                                <Dropdown className='w-100'
                                    value={statusFilter}
                                    options={[
                                        { label: 'Todos', value: '' },
                                        { label: 'Dentro da faixa', value: 'dentro' },
                                        { label: 'Acima da faixa', value: 'acima' },
                                        { label: 'Abaixo da faixa', value: 'abaixo' },
                                        { label: 'Sem estrutura', value: 'sem_estrutura' },
                                    ]}
                                    optionLabel='label'
                                    optionValue='value'
                                    showClear
                                    onChange={e => setStatusFilter(e.value || '')} />
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-success btn-sm' onClick={applyFilters}>
                                    <FontAwesomeIcon icon={solid('magnifying-glass')} /> Filtrar
                                </button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-link btn-sm text-grey text-decoration-none' onClick={clearFilters}>
                                    Limpar
                                </button>
                            </div>
                        </div>

                        {error && <div className='alert alert-danger mx-3'>{error}</div>}

                        <div className='row m-3'>
                            <div className='col bg-white border-clean pb-4'>
                                <p className='text-end mt-3 mb-1 text-muted small'><strong>{count}</strong> posições encontradas</p>

                                {loading && (
                                    <div className='text-center p-4'>
                                        <div className="spinner-border text-success" role="status" />
                                    </div>
                                )}

                                {!loading && items.length > 0 && (
                                    <>
                                        <div className='table-responsive'>
                                            <table className='table table-borderless thover borderBottom mt-2'>
                                                <thead className='borderBottom'>
                                                    <tr>
                                                        <th>Cargo</th>
                                                        <th>CBO</th>
                                                        <th>Organização</th>
                                                        <th>Departamento</th>
                                                        <th className='text-center'>Previstas</th>
                                                        <th className='text-center'>Alocados</th>
                                                        <th className='text-center'>Vagas</th>
                                                        <th>Estrutura</th>
                                                        <th className='text-end'>Mínimo</th>
                                                        <th className='text-end'>Midpoint</th>
                                                        <th className='text-end'>Máximo</th>
                                                        <th className='text-end'>Média Real</th>
                                                        <th className='text-center'>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td className='align-middle'>
                                                                <span className='text-green fw-bold' style={{cursor: 'pointer'}}
                                                                    onClick={() => { setSelection(item); setShowSidebar(true) }}>
                                                                    {item.internaljobtitle?.title || item.title}
                                                                </span>
                                                                <div className='text-muted small'>{item.internal_code}</div>
                                                            </td>
                                                            <td className='align-middle text-muted small'>
                                                                {item.internaljobtitle?.cbo_code || '-'}
                                                            </td>
                                                            <td className='align-middle'>{item.subcompany?.title || '-'}</td>
                                                            <td className='align-middle'>{item.department?.title || '-'}</td>
                                                            <td className='align-middle text-center'>{item.expected_positions}</td>
                                                            <td className='align-middle text-center'>{item.headcount}</td>
                                                            <td className='align-middle text-center'>
                                                                <span className={item.open_positions > 0 ? 'text-warning fw-bold' : 'text-success'}>
                                                                    {item.open_positions}
                                                                </span>
                                                            </td>
                                                            <td className='align-middle small'>
                                                                {item.pay_structure ? (
                                                                    <>{item.pay_structure.title}<br />
                                                                    <span className='text-muted'>{item.pay_grade?.title} — {item.pay_level?.title}</span></>
                                                                ) : <span className='text-muted'>-</span>}
                                                            </td>
                                                            <td className='align-middle text-end small'>
                                                                {item.min_salary !== null ? currencyFormat(item.min_salary) : '-'}
                                                            </td>
                                                            <td className='align-middle text-end small'>
                                                                {item.mid_salary !== null ? currencyFormat(item.mid_salary) : '-'}
                                                            </td>
                                                            <td className='align-middle text-end small'>
                                                                {item.max_salary !== null ? currencyFormat(item.max_salary) : '-'}
                                                            </td>
                                                            <td className='align-middle text-end small fw-bold'>
                                                                {item.avg_real_salary !== null ? currencyFormat(item.avg_real_salary) : '-'}
                                                            </td>
                                                            <td className='align-middle text-center'>
                                                                {STATUS_BADGE[item.salary_status] || '-'}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Paginação */}
                                        <div className='float-end'>
                                            <nav>
                                                <ul className='pagination pagination-sm'>
                                                    <li className='page-item'>
                                                        <button className='page-link' disabled={page === 1} onClick={() => setPage(page - 1)}>
                                                            <FontAwesomeIcon icon={solid('angle-left')} />
                                                        </button>
                                                    </li>
                                                    <li className='page-item'>
                                                        <span className='page-link text-muted'>{page}</span>
                                                    </li>
                                                    <li className='page-item'>
                                                        <button className='page-link' disabled={items.length < 50} onClick={() => setPage(page + 1)}>
                                                            <FontAwesomeIcon icon={solid('angle-right')} />
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </>
                                )}

                                {!loading && items.length === 0 && (
                                    <p className='text-center text-muted py-4'>Nenhuma posição encontrada com os filtros selecionados.</p>
                                )}
                            </div>
                        </div>

                        {/* Painel lateral de detalhe */}
                        <div className="card flex justify-content-center">
                            <Sidebar className="w-50" visible={showSidebar} position="right"
                                onHide={() => { setShowSidebar(false); setSelection(null) }}>
                                {selection && (
                                    <div>
                                        <p className='lead fw-bold text-default text-capitalize'>
                                            {selection.internaljobtitle?.title || selection.title}
                                            <small className='text-grey fw-normal ms-2'>({selection.internal_code})</small>
                                        </p>
                                        <hr />
                                        <div className='py-1'><strong>CBO:</strong> {selection.internaljobtitle?.cbo_code || '-'} — {selection.internaljobtitle?.cbo_title || ''}</div>
                                        <div className='py-1'><strong>Organização:</strong> {selection.subcompany?.title}</div>
                                        <div className='py-1'><strong>Departamento:</strong> {selection.department?.title}</div>
                                        <div className='py-1'><strong>Centro de Custo:</strong> {selection.costcenter?.title}</div>
                                        <div className='py-1'><strong>Posições Previstas:</strong> {selection.expected_positions}</div>
                                        <div className='py-1'><strong>Colaboradores:</strong> {selection.headcount}</div>
                                        <div className='py-1'><strong>Vagas Abertas:</strong> {selection.open_positions}</div>
                                        <hr />
                                        {selection.pay_structure ? (
                                            <>
                                                <div className='py-1'><strong>Estrutura:</strong> {selection.pay_structure.title}</div>
                                                <div className='py-1'><strong>Grau:</strong> {selection.pay_grade?.title}</div>
                                                <div className='py-1'><strong>Nível:</strong> {selection.pay_level?.title}</div>
                                                <div className='py-1'><strong>Faixa Mínima:</strong> {currencyFormat(selection.min_salary)}</div>
                                                <div className='py-1'><strong>Midpoint (100%):</strong> {currencyFormat(selection.mid_salary)}</div>
                                                <div className='py-1'><strong>Faixa Máxima:</strong> {currencyFormat(selection.max_salary)}</div>
                                                <div className='py-1'><strong>Salário Médio Real:</strong> {selection.avg_real_salary !== null ? currencyFormat(selection.avg_real_salary) : '-'}</div>
                                                <div className='py-1'><strong>Status:</strong> {STATUS_BADGE[selection.salary_status]}</div>
                                            </>
                                        ) : (
                                            <p className='text-muted'>Nenhuma estrutura salarial vinculada.</p>
                                        )}
                                    </div>
                                )}
                            </Sidebar>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
